import { render, staticRenderFns } from "./ggkEdit.vue?vue&type=template&id=640015d0&scoped=true"
import script from "./ggkEdit.vue?vue&type=script&lang=js"
export * from "./ggkEdit.vue?vue&type=script&lang=js"
import style0 from "./ggkEdit.vue?vue&type=style&index=0&id=640015d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640015d0",
  null
  
)

export default component.exports